import { Check } from 'lib/utils/formValidation/formValidation';
import isEmpty from 'lib/utils/formValidation/isEmpty';
import isNumeric from 'lib/utils/formValidation/isNumeric';

const isPositiveNumber: Check = (value) =>
  isEmpty(value) || (isNumeric(value) && Number(value) > 0);

export default isPositiveNumber;
